export default "__VITE_ASSET__DH_Uz_07__"